import { Application } from "@hotwired/stimulus";

import AccountingSystemFormController from "~/controllers/accounting-system-form";
import AdyenRevealController from "~/controllers/adyen-reveal";
import AdyenTransferInstrumentsController from "~/controllers/adyen-transfer-instruments";
import AutoDownloadController from "~/controllers/auto-download";
import AutosuggestController from "~/controllers/autosuggest";
import ChartController from "~/controllers/chart";
import ChartSwapController from "~/controllers/chart-swap";
import CheckboxGroupController from "~/controllers/checkbox-group";
import CommandPaletteController from "~/controllers/command-palette";
import CookieSettingsController from "~/controllers/cookie-settings";
import DropdownController from "~/controllers/dropdown";
import ExtensionAuthenticationController from "~/controllers/extension-authentication";
import ExtensionImportController from "~/controllers/extension-historical-imports";
import ExtensionStatusController from "~/controllers/extension-status";
import FormController from "~/controllers/form";
import InheritedPlaceholdersController from "~/controllers/inherited-placeholders";
import LazyLoadController from "~/controllers/lazy-load";
import LogoutController from "~/controllers/logout";
import MenuItemController from "~/controllers/menu-item";
import OneTimeCodeController from "~/controllers/one-time-code";
import {
  OverlayController,
  OverlayToggleController,
} from "~/controllers/overlay";
import PasskeyController from "~/controllers/passkey";
import PersonalCardFormController from "~/controllers/personal-card-form";
import SelectAllController from "~/controllers/select-all";
import {
  SidebarController,
  SidebarToggleController,
} from "~/controllers/sidebar";
import SlugifyController from "~/controllers/slugify";
import SplitButtonController from "~/controllers/split-button";
import StackCollapseController from "~/controllers/stack-collapse";
import SubBudgetController from "~/controllers/sub-budget";
import SupportChatController from "~/controllers/support-chat";
import QuarterlySpendController from "~/controllers/vibe_quarterly-spend";
import WebNavbarController from "~/controllers/web-navbar";

export const Stimulus = Application.start();
Stimulus.register("accounting-system-form", AccountingSystemFormController);
Stimulus.register("adyen-reveal", AdyenRevealController);
Stimulus.register(
  "adyen-transfer-instruments",
  AdyenTransferInstrumentsController,
);
Stimulus.register("auto-download", AutoDownloadController);
Stimulus.register("autosuggest", AutosuggestController);
Stimulus.register("chart", ChartController);
Stimulus.register("chart-swap", ChartSwapController);
Stimulus.register("checkbox-group", CheckboxGroupController);
Stimulus.register("command-palette", CommandPaletteController);
Stimulus.register("cookie-settings", CookieSettingsController);
Stimulus.register("dropdown", DropdownController);
Stimulus.register(
  "extension-authentication",
  ExtensionAuthenticationController,
);
Stimulus.register("extension-historical-import", ExtensionImportController);
Stimulus.register("extension-status", ExtensionStatusController);
Stimulus.register("form", FormController);
Stimulus.register("inherited-placeholders", InheritedPlaceholdersController);
Stimulus.register("lazy-load", LazyLoadController);
Stimulus.register("logout", LogoutController);
Stimulus.register("menu-item", MenuItemController);
Stimulus.register("one-time-code", OneTimeCodeController);
Stimulus.register("overlay", OverlayController);
Stimulus.register("overlay-toggle", OverlayToggleController);
Stimulus.register("passkey", PasskeyController);
Stimulus.register("quarterly-spend", QuarterlySpendController);
Stimulus.register("personal-card-form", PersonalCardFormController);
Stimulus.register("select-all", SelectAllController);
Stimulus.register("sidebar", SidebarController);
Stimulus.register("sidebar-toggle", SidebarToggleController);
Stimulus.register("slugify", SlugifyController);
Stimulus.register("split-button", SplitButtonController);
Stimulus.register("stack-collapse", StackCollapseController);
Stimulus.register("sub-budget", SubBudgetController);
Stimulus.register("support-chat", SupportChatController);
Stimulus.register("web-navbar", WebNavbarController);

declare global {
  interface Window {
    Stimulus: Application;
  }
}
window.Stimulus = Stimulus;
